import { baseUrl, isSignedIn, getHeaders } from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

export async function GetIndicatorsByUser() {
    await isSignedIn();

    const query = queryFilter({ lastMonths: 12 });
    const urlApi = `${baseUrl}/MyGarage/user/indicators${query}`;

    return axios.get(urlApi, getHeaders(true));
}
